export const planSummaryReactivation = () => ({
  type: 'View Plan Summary - Reactivation',
});

export const planReactivateClicked = () => ({
  type: 'View Plan Summary - Reactivated Pup',
});
